import { Badge, Placeholder, Spinner, Card } from 'react-bootstrap';

const TaskCardSkeleton = () => (
  <Card className="mb-2 task-card">
    <Card.Body>
      <div className="d-flex justify-content-between mb-2">
        <Placeholder as={Badge} animation="glow" bg="secondary" pill>
          <Placeholder xs={4} />
        </Placeholder>
        <Spinner animation="border" size="sm" />
      </div>
      <Placeholder as="h6" animation="glow">
        <Placeholder xs={8} />
      </Placeholder>
      <Placeholder as="p" animation="glow" className="small mb-2">
        <Placeholder xs={12} />
      </Placeholder>
      <Placeholder as="div" animation="glow" className="small mb-2 text-muted">
        <Placeholder xs={6} />
      </Placeholder>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <Placeholder as="div" animation="glow" className="small text-muted">
          <Placeholder xs={4} />
        </Placeholder>
        <Placeholder as="div" animation="glow">
          <Placeholder xs={2} />
        </Placeholder>
      </div>
    </Card.Body>
  </Card>
);

export default TaskCardSkeleton;
